import React, { useRef } from "react"
import {
  Modal,
  Typography,
  Space,
  Button,
  message,
  Alert,
} from "@mimber/ui-web"
import { SendOutlined } from "@mimber/ui-web"
import { usePublishEvent } from "@mimber/client/mimber-organization"
import type { PublishEventModalProps } from "./PublishEventModal.types"

const { Paragraph } = Typography

export const PublishEventModal: React.FunctionComponent<
  PublishEventModalProps
> = ({ event, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)
  const externalOnCancel = (modalProps as { onCancel?: () => void }).onCancel

  const mutation = usePublishEvent(event.uuid, {
    onSuccess: () => {
      message.success("Event published successfully")
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to publish event: ${error.message}`)
    },
  })

  return (
    <Modal title="Publish Event" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Alert
              type="info"
              title="Event will be visible to members"
              description="Publishing will change this event's status to Published and make it visible to members based on its visibility setting."
              showIcon
            />
            <Paragraph>
              Are you sure you want to publish <strong>{event.title}</strong>?
            </Paragraph>
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button
                onClick={() => {
                  close()
                  externalOnCancel?.()
                }}
                disabled={mutation.isPending}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                icon={<SendOutlined />}
                loading={mutation.isPending}
                onClick={() => mutation.mutate()}
              >
                Publish Event
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
